import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Mercado} from "../../model/mercado/mercado";
import {MercadoStorageService} from "../../storage/mercado/mercado-storage.service";
import {UsuarioLogadoStorageService} from "../../storage/usuario/usuario-logado-storage.service";
import { UsuarioUtil } from '../../util/usuario-util';
import { AmfUtil } from '../../util/amf-util';
import { LoginService } from '../../service/auth/login.service';

interface Option {
    value: string;
    label: string;
}

@Component({
    selector: 'app-filial',
    templateUrl: './filial.component.html',
    styleUrls: ['./filial.component.scss']
})
export class FilialComponent implements OnInit {

    @Input() title = 'Selecione um mercado';

    @Input() mercado: string;
    @Output() mercadoChange = new EventEmitter<string>();

    mercados: Option[] = new Array<Option>();
    mostraSelectMercados: boolean;

    constructor(private mercadoStorage: MercadoStorageService,
                private _loginService: LoginService,
                private usuarioLogadoStorage: UsuarioLogadoStorageService) {
    }

    ngOnInit() {
        this.mercadoStorage.get().forEach(mercado => this.mercados.push({
            value: mercado.id.toString(), 
            label: `${mercado.clienteSgs} - ${mercado.nome}`
        }));
        this.mercado = this.usuarioLogadoStorage.get().usuario.cadastrao.id.toString();
        this.mostraSelectMercados = this.usuarioLogadoStorage.get().isMostraSelectMercados();
    }

    async onModelChange() {
        await this.trocarUsuario();
        this.mercadoChange.emit(this.mercado);
    }

    private async trocarUsuario() {
        try {
            let res = await this._loginService.trocarUsuario(+this.mercado);

            if (AmfUtil.validarResponse(res)) {
                let usuarioLogado = this.usuarioLogadoStorage.get();
                let usuario = UsuarioUtil.getInstance();
                usuarioLogado.usuario = Object.assign(usuario, res.data.body);
                this.usuarioLogadoStorage.set(usuarioLogado);
            }
        } catch (e) {
            console.error('[FilialComponent] Erro ao trocar a pesquisa', e);
        }
    }

}